export default {
    v: "5.7.6",
    fr: 25,
    ip: 0,
    op: 50,
    w: 90,
    h: 90,
    nm: "合成 1",
    ddd: 0,
    assets: [
      {
        id: "image_0",
        w: 820,
        h: 680,
        u: "images/",
        p: "img_0.png",
        e: 0,
      },
      {
        id: "comp_0",
        layers: [
          {
            ddd: 0,
            ind: 1,
            ty: 4,
            nm: "“zixun”轮廓 2",
            sr: 1,
            ks: {
              o: {
                a: 0,
                k: 100,
                ix: 11,
              },
              r: {
                a: 0,
                k: 0,
                ix: 10,
              },
              p: {
                a: 0,
                k: [44.875, 30.5, 0],
                ix: 2,
                l: 2,
              },
              a: {
                a: 0,
                k: [410, 340, 0],
                ix: 1,
                l: 2,
              },
              s: {
                a: 0,
                k: [8, 8, 100],
                ix: 6,
                l: 2,
              },
            },
            ao: 0,
            ef: [
              {
                ty: 25,
                nm: "投影",
                np: 8,
                mn: "ADBE Drop Shadow",
                ix: 1,
                en: 1,
                ef: [
                  {
                    ty: 2,
                    nm: "阴影颜色",
                    mn: "ADBE Drop Shadow-0001",
                    ix: 1,
                    v: {
                      a: 0,
                      k: [0.051075682044, 0.233403071761, 0.871548891068, 1],
                      ix: 1,
                    },
                  },
                  {
                    ty: 0,
                    nm: "不透明度",
                    mn: "ADBE Drop Shadow-0002",
                    ix: 2,
                    v: {
                      a: 0,
                      k: 102,
                      ix: 2,
                    },
                  },
                  {
                    ty: 0,
                    nm: "方向",
                    mn: "ADBE Drop Shadow-0003",
                    ix: 3,
                    v: {
                      a: 0,
                      k: -50,
                      ix: 3,
                    },
                  },
                  {
                    ty: 0,
                    nm: "距离",
                    mn: "ADBE Drop Shadow-0004",
                    ix: 4,
                    v: {
                      a: 0,
                      k: 4,
                      ix: 4,
                    },
                  },
                  {
                    ty: 0,
                    nm: "柔和度",
                    mn: "ADBE Drop Shadow-0005",
                    ix: 5,
                    v: {
                      a: 0,
                      k: 12,
                      ix: 5,
                    },
                  },
                  {
                    ty: 7,
                    nm: "仅阴影",
                    mn: "ADBE Drop Shadow-0006",
                    ix: 6,
                    v: {
                      a: 0,
                      k: 0,
                      ix: 6,
                    },
                  },
                ],
              },
            ],
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [24.742, 0],
                          [0, -24.742],
                          [-24.742, 0],
                          [0, 24.742],
                        ],
                        o: [
                          [-24.742, 0],
                          [0, 24.742],
                          [24.742, 0],
                          [0, -24.742],
                        ],
                        v: [
                          [-166.398, -102.863],
                          [-211.199, -58.066],
                          [-166.398, -13.265],
                          [-121.597, -58.066],
                        ],
                        c: true,
                      },
                      ix: 2,
                    },
                    nm: "路径 2",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [24.742, 0],
                          [0, -24.742],
                          [-24.742, 0],
                          [0, 24.742],
                        ],
                        o: [
                          [-24.742, 0],
                          [0, 24.742],
                          [24.742, 0],
                          [0, -24.742],
                        ],
                        v: [
                          [0, -102.863],
                          [-44.801, -58.066],
                          [0, -13.265],
                          [44.801, -58.066],
                        ],
                        c: true,
                      },
                      ix: 2,
                    },
                    nm: "路径 3",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ind: 2,
                    ty: "sh",
                    ix: 3,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [24.742, 0],
                          [0, -24.742],
                          [-24.743, 0],
                          [0, 24.742],
                        ],
                        o: [
                          [-24.743, 0],
                          [0, 24.742],
                          [24.742, 0],
                          [0, -24.742],
                        ],
                        v: [
                          [166.403, -102.863],
                          [121.602, -58.066],
                          [166.403, -13.265],
                          [211.199, -58.066],
                        ],
                        c: true,
                      },
                      ix: 2,
                    },
                    nm: "路径 4",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "合并路径 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false,
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [1, 1, 1, 1],
                      ix: 4,
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 5,
                    },
                    r: 1,
                    bm: 0,
                    nm: "填充 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false,
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [499.199, 385.054],
                      ix: 2,
                    },
                    a: {
                      a: 0,
                      k: [0, 0],
                      ix: 1,
                    },
                    s: {
                      a: 0,
                      k: [100, 100],
                      ix: 3,
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6,
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7,
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4,
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5,
                    },
                    nm: "变换",
                  },
                ],
                nm: "组 1",
                np: 5,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false,
              },
            ],
            ip: 0,
            op: 51,
            st: 0,
            bm: 0,
          },
          {
            ddd: 0,
            ind: 2,
            ty: 4,
            nm: "“zixun”轮廓 3",
            sr: 1,
            ks: {
              o: {
                a: 0,
                k: 100,
                ix: 11,
              },
              r: {
                a: 0,
                k: 0,
                ix: 10,
              },
              p: {
                a: 0,
                k: [44.875, 30.5, 0],
                ix: 2,
                l: 2,
              },
              a: {
                a: 0,
                k: [410, 340, 0],
                ix: 1,
                l: 2,
              },
              s: {
                a: 0,
                k: [8, 8, 100],
                ix: 6,
                l: 2,
              },
            },
            ao: 0,
            ef: [
              {
                ty: 25,
                nm: "投影",
                np: 8,
                mn: "ADBE Drop Shadow",
                ix: 1,
                en: 1,
                ef: [
                  {
                    ty: 2,
                    nm: "阴影颜色",
                    mn: "ADBE Drop Shadow-0001",
                    ix: 1,
                    v: {
                      a: 0,
                      k: [0.207843154669, 0.372549027205, 0.95294123888, 1],
                      ix: 1,
                    },
                  },
                  {
                    ty: 0,
                    nm: "不透明度",
                    mn: "ADBE Drop Shadow-0002",
                    ix: 2,
                    v: {
                      a: 0,
                      k: 102,
                      ix: 2,
                    },
                  },
                  {
                    ty: 0,
                    nm: "方向",
                    mn: "ADBE Drop Shadow-0003",
                    ix: 3,
                    v: {
                      a: 0,
                      k: -50,
                      ix: 3,
                    },
                  },
                  {
                    ty: 0,
                    nm: "距离",
                    mn: "ADBE Drop Shadow-0004",
                    ix: 4,
                    v: {
                      a: 0,
                      k: 2,
                      ix: 4,
                    },
                  },
                  {
                    ty: 0,
                    nm: "柔和度",
                    mn: "ADBE Drop Shadow-0005",
                    ix: 5,
                    v: {
                      a: 0,
                      k: 16,
                      ix: 5,
                    },
                  },
                  {
                    ty: 7,
                    nm: "仅阴影",
                    mn: "ADBE Drop Shadow-0006",
                    ix: 6,
                    v: {
                      a: 0,
                      k: 0,
                      ix: 6,
                    },
                  },
                ],
              },
            ],
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [35.348, 0],
                          [0, 0],
                          [0, 0],
                          [5.66, -4.89],
                          [7.367, 1.293],
                          [5.618, 5.598],
                          [0, 0],
                          [0, 0],
                          [0, 35.347],
                          [0, 0],
                          [-35.344, 0],
                          [0, 0],
                          [0, -35.347],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0.215, 7.477],
                          [-5.657, 4.895],
                          [-7.868, 0.98],
                          [0, 0],
                          [0, 0],
                          [-35.344, 0],
                          [0, 0],
                          [0, -35.347],
                          [0, 0],
                          [35.348, 0],
                          [0, 0],
                          [0, 35.347],
                        ],
                        v: [
                          [256, 178.735],
                          [172.801, 178.735],
                          [172.801, 268.336],
                          [164.196, 287.883],
                          [143.61, 293.571],
                          [122.242, 286.254],
                          [14.723, 178.735],
                          [-256, 178.735],
                          [-320, 114.735],
                          [-320, -230.863],
                          [-256, -294.863],
                          [256, -294.863],
                          [320, -230.863],
                          [320, 114.735],
                        ],
                        c: true,
                      },
                      ix: 2,
                    },
                    nm: "路径 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [24.742, 0],
                          [0, -24.742],
                          [-24.742, 0],
                          [0, 24.742],
                        ],
                        o: [
                          [-24.742, 0],
                          [0, 24.742],
                          [24.742, 0],
                          [0, -24.742],
                        ],
                        v: [
                          [-166.398, -102.863],
                          [-211.199, -58.066],
                          [-166.398, -13.265],
                          [-121.597, -58.066],
                        ],
                        c: true,
                      },
                      ix: 2,
                    },
                    nm: "路径 2",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ind: 2,
                    ty: "sh",
                    ix: 3,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [24.742, 0],
                          [0, -24.742],
                          [-24.742, 0],
                          [0, 24.742],
                        ],
                        o: [
                          [-24.742, 0],
                          [0, 24.742],
                          [24.742, 0],
                          [0, -24.742],
                        ],
                        v: [
                          [0, -102.863],
                          [-44.801, -58.066],
                          [0, -13.265],
                          [44.801, -58.066],
                        ],
                        c: true,
                      },
                      ix: 2,
                    },
                    nm: "路径 3",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ind: 3,
                    ty: "sh",
                    ix: 4,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [24.742, 0],
                          [0, -24.742],
                          [-24.743, 0],
                          [0, 24.742],
                        ],
                        o: [
                          [-24.743, 0],
                          [0, 24.742],
                          [24.742, 0],
                          [0, -24.742],
                        ],
                        v: [
                          [166.403, -102.863],
                          [121.602, -58.066],
                          [166.403, -13.265],
                          [211.199, -58.066],
                        ],
                        c: true,
                      },
                      ix: 2,
                    },
                    nm: "路径 4",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ind: 4,
                    ty: "sh",
                    ix: 5,
                    ks: {
                      a: 0,
                      k: {
                        i: [[0, 0]],
                        o: [[0, 0]],
                        v: [[166.403, -102.863]],
                        c: false,
                      },
                      ix: 2,
                    },
                    nm: "路径 5",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "合并路径 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false,
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0.215686276555, 0.380392163992, 0.956862747669, 1],
                      ix: 4,
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 5,
                    },
                    r: 1,
                    bm: 0,
                    nm: "填充 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false,
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [499.199, 385.054],
                      ix: 2,
                    },
                    a: {
                      a: 0,
                      k: [0, 0],
                      ix: 1,
                    },
                    s: {
                      a: 0,
                      k: [100, 100],
                      ix: 3,
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6,
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7,
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4,
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5,
                    },
                    nm: "变换",
                  },
                ],
                nm: "组 1",
                np: 7,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false,
              },
            ],
            ip: 0,
            op: 51,
            st: 0,
            bm: 0,
          },
        ],
      },
      {
        id: "comp_1",
        layers: [
          {
            ddd: 0,
            ind: 1,
            ty: 4,
            nm: "“zixun”轮廓 2",
            sr: 1,
            ks: {
              o: {
                a: 0,
                k: 100,
                ix: 11,
              },
              r: {
                a: 0,
                k: 0,
                ix: 10,
              },
              p: {
                a: 0,
                k: [44.875, 30.5, 0],
                ix: 2,
                l: 2,
              },
              a: {
                a: 0,
                k: [410, 340, 0],
                ix: 1,
                l: 2,
              },
              s: {
                a: 0,
                k: [8, 8, 100],
                ix: 6,
                l: 2,
              },
            },
            ao: 0,
            ef: [
              {
                ty: 25,
                nm: "投影",
                np: 8,
                mn: "ADBE Drop Shadow",
                ix: 1,
                en: 1,
                ef: [
                  {
                    ty: 2,
                    nm: "阴影颜色",
                    mn: "ADBE Drop Shadow-0001",
                    ix: 1,
                    v: {
                      a: 0,
                      k: [0.051075682044, 0.233403071761, 0.871548891068, 1],
                      ix: 1,
                    },
                  },
                  {
                    ty: 0,
                    nm: "不透明度",
                    mn: "ADBE Drop Shadow-0002",
                    ix: 2,
                    v: {
                      a: 0,
                      k: 102,
                      ix: 2,
                    },
                  },
                  {
                    ty: 0,
                    nm: "方向",
                    mn: "ADBE Drop Shadow-0003",
                    ix: 3,
                    v: {
                      a: 0,
                      k: -50,
                      ix: 3,
                    },
                  },
                  {
                    ty: 0,
                    nm: "距离",
                    mn: "ADBE Drop Shadow-0004",
                    ix: 4,
                    v: {
                      a: 0,
                      k: 4,
                      ix: 4,
                    },
                  },
                  {
                    ty: 0,
                    nm: "柔和度",
                    mn: "ADBE Drop Shadow-0005",
                    ix: 5,
                    v: {
                      a: 0,
                      k: 12,
                      ix: 5,
                    },
                  },
                  {
                    ty: 7,
                    nm: "仅阴影",
                    mn: "ADBE Drop Shadow-0006",
                    ix: 6,
                    v: {
                      a: 0,
                      k: 0,
                      ix: 6,
                    },
                  },
                ],
              },
            ],
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [24.742, 0],
                          [0, -24.742],
                          [-24.742, 0],
                          [0, 24.742],
                        ],
                        o: [
                          [-24.742, 0],
                          [0, 24.742],
                          [24.742, 0],
                          [0, -24.742],
                        ],
                        v: [
                          [-166.398, -102.863],
                          [-211.199, -58.066],
                          [-166.398, -13.265],
                          [-121.597, -58.066],
                        ],
                        c: true,
                      },
                      ix: 2,
                    },
                    nm: "路径 2",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [24.742, 0],
                          [0, -24.742],
                          [-24.742, 0],
                          [0, 24.742],
                        ],
                        o: [
                          [-24.742, 0],
                          [0, 24.742],
                          [24.742, 0],
                          [0, -24.742],
                        ],
                        v: [
                          [0, -102.863],
                          [-44.801, -58.066],
                          [0, -13.265],
                          [44.801, -58.066],
                        ],
                        c: true,
                      },
                      ix: 2,
                    },
                    nm: "路径 3",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ind: 2,
                    ty: "sh",
                    ix: 3,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [24.742, 0],
                          [0, -24.742],
                          [-24.743, 0],
                          [0, 24.742],
                        ],
                        o: [
                          [-24.743, 0],
                          [0, 24.742],
                          [24.742, 0],
                          [0, -24.742],
                        ],
                        v: [
                          [166.403, -102.863],
                          [121.602, -58.066],
                          [166.403, -13.265],
                          [211.199, -58.066],
                        ],
                        c: true,
                      },
                      ix: 2,
                    },
                    nm: "路径 4",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "合并路径 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false,
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [1, 1, 1, 1],
                      ix: 4,
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 5,
                    },
                    r: 1,
                    bm: 0,
                    nm: "填充 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false,
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [499.199, 385.054],
                      ix: 2,
                    },
                    a: {
                      a: 0,
                      k: [0, 0],
                      ix: 1,
                    },
                    s: {
                      a: 0,
                      k: [100, 100],
                      ix: 3,
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6,
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7,
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4,
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5,
                    },
                    nm: "变换",
                  },
                ],
                nm: "组 1",
                np: 5,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false,
              },
            ],
            ip: 0,
            op: 51,
            st: 0,
            bm: 0,
          },
          {
            ddd: 0,
            ind: 2,
            ty: 4,
            nm: "“zixun”轮廓 3",
            sr: 1,
            ks: {
              o: {
                a: 0,
                k: 100,
                ix: 11,
              },
              r: {
                a: 0,
                k: 0,
                ix: 10,
              },
              p: {
                a: 0,
                k: [44.875, 30.5, 0],
                ix: 2,
                l: 2,
              },
              a: {
                a: 0,
                k: [410, 340, 0],
                ix: 1,
                l: 2,
              },
              s: {
                a: 0,
                k: [8, 8, 100],
                ix: 6,
                l: 2,
              },
            },
            ao: 0,
            ef: [
              {
                ty: 25,
                nm: "投影",
                np: 8,
                mn: "ADBE Drop Shadow",
                ix: 1,
                en: 1,
                ef: [
                  {
                    ty: 2,
                    nm: "阴影颜色",
                    mn: "ADBE Drop Shadow-0001",
                    ix: 1,
                    v: {
                      a: 0,
                      k: [0.207843154669, 0.372549027205, 0.95294123888, 1],
                      ix: 1,
                    },
                  },
                  {
                    ty: 0,
                    nm: "不透明度",
                    mn: "ADBE Drop Shadow-0002",
                    ix: 2,
                    v: {
                      a: 0,
                      k: 102,
                      ix: 2,
                    },
                  },
                  {
                    ty: 0,
                    nm: "方向",
                    mn: "ADBE Drop Shadow-0003",
                    ix: 3,
                    v: {
                      a: 0,
                      k: -50,
                      ix: 3,
                    },
                  },
                  {
                    ty: 0,
                    nm: "距离",
                    mn: "ADBE Drop Shadow-0004",
                    ix: 4,
                    v: {
                      a: 0,
                      k: 2,
                      ix: 4,
                    },
                  },
                  {
                    ty: 0,
                    nm: "柔和度",
                    mn: "ADBE Drop Shadow-0005",
                    ix: 5,
                    v: {
                      a: 0,
                      k: 16,
                      ix: 5,
                    },
                  },
                  {
                    ty: 7,
                    nm: "仅阴影",
                    mn: "ADBE Drop Shadow-0006",
                    ix: 6,
                    v: {
                      a: 0,
                      k: 0,
                      ix: 6,
                    },
                  },
                ],
              },
            ],
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [35.348, 0],
                          [0, 0],
                          [0, 0],
                          [5.66, -4.89],
                          [7.367, 1.293],
                          [5.618, 5.598],
                          [0, 0],
                          [0, 0],
                          [0, 35.347],
                          [0, 0],
                          [-35.344, 0],
                          [0, 0],
                          [0, -35.347],
                          [0, 0],
                        ],
                        o: [
                          [0, 0],
                          [0, 0],
                          [0.215, 7.477],
                          [-5.657, 4.895],
                          [-7.868, 0.98],
                          [0, 0],
                          [0, 0],
                          [-35.344, 0],
                          [0, 0],
                          [0, -35.347],
                          [0, 0],
                          [35.348, 0],
                          [0, 0],
                          [0, 35.347],
                        ],
                        v: [
                          [256, 178.735],
                          [172.801, 178.735],
                          [172.801, 268.336],
                          [164.196, 287.883],
                          [143.61, 293.571],
                          [122.242, 286.254],
                          [14.723, 178.735],
                          [-256, 178.735],
                          [-320, 114.735],
                          [-320, -230.863],
                          [-256, -294.863],
                          [256, -294.863],
                          [320, -230.863],
                          [320, 114.735],
                        ],
                        c: true,
                      },
                      ix: 2,
                    },
                    nm: "路径 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [24.742, 0],
                          [0, -24.742],
                          [-24.742, 0],
                          [0, 24.742],
                        ],
                        o: [
                          [-24.742, 0],
                          [0, 24.742],
                          [24.742, 0],
                          [0, -24.742],
                        ],
                        v: [
                          [-166.398, -102.863],
                          [-211.199, -58.066],
                          [-166.398, -13.265],
                          [-121.597, -58.066],
                        ],
                        c: true,
                      },
                      ix: 2,
                    },
                    nm: "路径 2",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ind: 2,
                    ty: "sh",
                    ix: 3,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [24.742, 0],
                          [0, -24.742],
                          [-24.742, 0],
                          [0, 24.742],
                        ],
                        o: [
                          [-24.742, 0],
                          [0, 24.742],
                          [24.742, 0],
                          [0, -24.742],
                        ],
                        v: [
                          [0, -102.863],
                          [-44.801, -58.066],
                          [0, -13.265],
                          [44.801, -58.066],
                        ],
                        c: true,
                      },
                      ix: 2,
                    },
                    nm: "路径 3",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ind: 3,
                    ty: "sh",
                    ix: 4,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [24.742, 0],
                          [0, -24.742],
                          [-24.743, 0],
                          [0, 24.742],
                        ],
                        o: [
                          [-24.743, 0],
                          [0, 24.742],
                          [24.742, 0],
                          [0, -24.742],
                        ],
                        v: [
                          [166.403, -102.863],
                          [121.602, -58.066],
                          [166.403, -13.265],
                          [211.199, -58.066],
                        ],
                        c: true,
                      },
                      ix: 2,
                    },
                    nm: "路径 4",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ind: 4,
                    ty: "sh",
                    ix: 5,
                    ks: {
                      a: 0,
                      k: {
                        i: [[0, 0]],
                        o: [[0, 0]],
                        v: [[166.403, -102.863]],
                        c: false,
                      },
                      ix: 2,
                    },
                    nm: "路径 5",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "合并路径 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false,
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0.215686276555, 0.380392163992, 0.956862747669, 1],
                      ix: 4,
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 5,
                    },
                    r: 1,
                    bm: 0,
                    nm: "填充 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false,
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [499.199, 385.054],
                      ix: 2,
                    },
                    a: {
                      a: 0,
                      k: [0, 0],
                      ix: 1,
                    },
                    s: {
                      a: 0,
                      k: [100, 100],
                      ix: 3,
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6,
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7,
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4,
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5,
                    },
                    nm: "变换",
                  },
                ],
                nm: "组 1",
                np: 7,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false,
              },
            ],
            ip: 0,
            op: 51,
            st: 0,
            bm: 0,
          },
          {
            ddd: 0,
            ind: 3,
            ty: 4,
            nm: "“zixun”轮廓",
            sr: 1,
            ks: {
              o: {
                a: 0,
                k: 100,
                ix: 11,
              },
              r: {
                a: 0,
                k: 0,
                ix: 10,
              },
              p: {
                a: 0,
                k: [44.875, 30.5, 0],
                ix: 2,
                l: 2,
              },
              a: {
                a: 0,
                k: [410, 340, 0],
                ix: 1,
                l: 2,
              },
              s: {
                a: 0,
                k: [8, 8, 100],
                ix: 6,
                l: 2,
              },
            },
            ao: 0,
            shapes: [
              {
                ty: "gr",
                it: [
                  {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                      a: 0,
                      k: {
                        i: [
                          [0, 0],
                          [0, 0],
                          [7.879, 0.98],
                          [1.214, -0.035],
                          [0, 14.137],
                          [0, 0],
                          [0, 0],
                          [0, 35.347],
                          [0, 0],
                          [-35.348, 0],
                          [0, 0],
                          [0, -35.348],
                          [0, 0],
                          [90.512, -98.879],
                        ],
                        o: [
                          [0, 0],
                          [-5.633, 5.594],
                          [-1.196, 0.211],
                          [-14.141, 0],
                          [0, 0],
                          [0, 0],
                          [-35.348, 0],
                          [0, 0],
                          [0, -35.348],
                          [0, 0],
                          [35.343, 0],
                          [0, 0],
                          [0, 0],
                          [-70.035, 76.52],
                        ],
                        v: [
                          [-73.662, 202.691],
                          [-106.236, 235.214],
                          [-127.638, 242.523],
                          [-131.259, 242.894],
                          [-156.861, 217.296],
                          [-156.861, 140.496],
                          [-188.861, 140.496],
                          [-252.861, 76.496],
                          [-252.861, -179.504],
                          [-188.861, -243.503],
                          [188.741, -243.503],
                          [252.741, -179.504],
                          [252.741, -153.903],
                          [41.537, 18.895],
                        ],
                        c: true,
                      },
                      ix: 2,
                    },
                    nm: "路径 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ind: 1,
                    ty: "sh",
                    ix: 2,
                    ks: {
                      a: 0,
                      k: {
                        i: [[0, 0]],
                        o: [[0, 0]],
                        v: [[-73.662, 202.691]],
                        c: false,
                      },
                      ix: 2,
                    },
                    nm: "路径 2",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                  },
                  {
                    ty: "mm",
                    mm: 1,
                    nm: "合并路径 1",
                    mn: "ADBE Vector Filter - Merge",
                    hd: false,
                  },
                  {
                    ty: "fl",
                    c: {
                      a: 0,
                      k: [0.235294118524, 0.721568644047, 1, 1],
                      ix: 4,
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 5,
                    },
                    r: 1,
                    bm: 0,
                    nm: "填充 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false,
                  },
                  {
                    ty: "tr",
                    p: {
                      a: 0,
                      k: [252.861, 244.094],
                      ix: 2,
                    },
                    a: {
                      a: 0,
                      k: [0, 0],
                      ix: 1,
                    },
                    s: {
                      a: 0,
                      k: [100, 100],
                      ix: 3,
                    },
                    r: {
                      a: 0,
                      k: 0,
                      ix: 6,
                    },
                    o: {
                      a: 0,
                      k: 100,
                      ix: 7,
                    },
                    sk: {
                      a: 0,
                      k: 0,
                      ix: 4,
                    },
                    sa: {
                      a: 0,
                      k: 0,
                      ix: 5,
                    },
                    nm: "变换",
                  },
                ],
                nm: "组 2",
                np: 6,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false,
              },
            ],
            ip: 0,
            op: 51,
            st: 0,
            bm: 0,
          },
        ],
      },
    ],
    fonts: {
      list: [
        {
          fName: "PingFangSC-Medium",
          fFamily: "PingFang SC",
          fStyle: "Medium",
          ascent: 72.7996826171875,
        },
      ],
    },
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 0,
        nm: "预合成 1",
        refId: "comp_0",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11,
          },
          r: {
            a: 1,
            k: [
              {
                i: {
                  x: [0.52],
                  y: [0.96],
                },
                o: {
                  x: [0.48],
                  y: [0.04],
                },
                t: 0,
                s: [0],
              },
              {
                i: {
                  x: [0.52],
                  y: [0.96],
                },
                o: {
                  x: [0.48],
                  y: [0.04],
                },
                t: 5,
                s: [5],
              },
              {
                i: {
                  x: [0.52],
                  y: [0.96],
                },
                o: {
                  x: [0.48],
                  y: [0.04],
                },
                t: 15,
                s: [-10],
              },
              {
                t: 20,
                s: [0],
              },
            ],
            ix: 10,
          },
          p: {
            a: 0,
            k: [63.75, 57, 0],
            ix: 2,
            l: 2,
          },
          a: {
            a: 0,
            k: [63.75, 57, 0],
            ix: 1,
            l: 2,
          },
          s: {
            a: 1,
            k: [
              {
                i: {
                  x: [0.52, 0.52, 0.52],
                  y: [0.96, 0.96, 1],
                },
                o: {
                  x: [0.48, 0.48, 0.48],
                  y: [0.04, 0.04, 0],
                },
                t: 20,
                s: [100, 100, 100],
              },
              {
                i: {
                  x: [0.52, 0.52, 0.52],
                  y: [0.96, 0.96, 1],
                },
                o: {
                  x: [0.48, 0.48, 0.48],
                  y: [0.04, 0.04, 0],
                },
                t: 25,
                s: [106, 106, 100],
              },
              {
                t: 30,
                s: [100, 100, 100],
              },
            ],
            ix: 6,
            l: 2,
          },
        },
        ao: 0,
        w: 90,
        h: 90,
        ip: 0,
        op: 50,
        st: 0,
        bm: 0,
      },
      {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "“zixun”轮廓",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11,
          },
          r: {
            a: 1,
            k: [
              {
                i: {
                  x: [0.52],
                  y: [0.96],
                },
                o: {
                  x: [0.48],
                  y: [0.04],
                },
                t: 0,
                s: [0],
              },
              {
                i: {
                  x: [0.52],
                  y: [0.96],
                },
                o: {
                  x: [0.48],
                  y: [0.04],
                },
                t: 5,
                s: [-5],
              },
              {
                i: {
                  x: [0.52],
                  y: [0.96],
                },
                o: {
                  x: [0.48],
                  y: [0.04],
                },
                t: 15,
                s: [10],
              },
              {
                t: 20,
                s: [0],
              },
            ],
            ix: 10,
          },
          p: {
            a: 0,
            k: [21.625, 42.125, 0],
            ix: 2,
            l: 2,
          },
          a: {
            a: 0,
            k: [119.375, 485.312, 0],
            ix: 1,
            l: 2,
          },
          s: {
            a: 1,
            k: [
              {
                i: {
                  x: [0.52, 0.52, 0.52],
                  y: [0.96, 0.96, 1],
                },
                o: {
                  x: [0.48, 0.48, 0.48],
                  y: [0.04, 0.04, 0],
                },
                t: 20,
                s: [8, 8, 100],
              },
              {
                i: {
                  x: [0.52, 0.52, 0.52],
                  y: [0.96, 0.96, 1],
                },
                o: {
                  x: [0.48, 0.48, 0.48],
                  y: [0.04, 0.04, 0],
                },
                t: 25,
                s: [8.4, 8.4, 100],
              },
              {
                t: 30,
                s: [8, 8, 100],
              },
            ],
            ix: 6,
            l: 2,
          },
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [7.879, 0.98],
                      [1.214, -0.035],
                      [0, 14.137],
                      [0, 0],
                      [0, 0],
                      [0, 35.347],
                      [0, 0],
                      [-35.348, 0],
                      [0, 0],
                      [0, -35.348],
                      [0, 0],
                      [4.664, -4.238],
                      [99.775, -4.107],
                    ],
                    o: [
                      [0, 0],
                      [-5.633, 5.594],
                      [-1.196, 0.211],
                      [-14.141, 0],
                      [0, 0],
                      [0, 0],
                      [-35.348, 0],
                      [0, 0],
                      [0, -35.348],
                      [0, 0],
                      [35.343, 0],
                      [0, 0],
                      [0, 0],
                      [-7.548, 6.858],
                      [-32.4, 1.334],
                    ],
                    v: [
                      [-73.662, 202.691],
                      [-106.236, 235.214],
                      [-127.638, 242.523],
                      [-131.259, 242.894],
                      [-156.861, 217.296],
                      [-156.861, 140.496],
                      [-188.861, 140.496],
                      [-252.861, 76.496],
                      [-252.861, -179.504],
                      [-188.861, -243.503],
                      [188.741, -243.503],
                      [252.741, -179.504],
                      [252.741, -153.903],
                      [246.225, 123.582],
                      [5.802, 139.076],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "路径 1",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [[0, 0]],
                    o: [[0, 0]],
                    v: [[-73.662, 202.691]],
                    c: false,
                  },
                  ix: 2,
                },
                nm: "路径 2",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ty: "mm",
                mm: 1,
                nm: "合并路径 1",
                mn: "ADBE Vector Filter - Merge",
                hd: false,
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [0.235294118524, 0.721568644047, 1, 1],
                  ix: 4,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5,
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false,
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [252.861, 244.094],
                  ix: 2,
                },
                a: {
                  a: 0,
                  k: [0, 0],
                  ix: 1,
                },
                s: {
                  a: 0,
                  k: [100, 100],
                  ix: 3,
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7,
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4,
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5,
                },
                nm: "变换",
              },
            ],
            nm: "组 2",
            np: 6,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
        ip: 0,
        op: 51,
        st: 0,
        bm: 0,
      },
      {
        ddd: 0,
        ind: 3,
        ty: 0,
        nm: "咨询",
        hd: true,
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11,
          },
          r: {
            a: 1,
            k: [
              {
                i: {
                  x: [0.58],
                  y: [1],
                },
                o: {
                  x: [0.42],
                  y: [0],
                },
                t: 0,
                s: [0],
              },
              {
                i: {
                  x: [0.58],
                  y: [1],
                },
                o: {
                  x: [0.42],
                  y: [0],
                },
                t: 4,
                s: [0],
              },
              {
                i: {
                  x: [0.58],
                  y: [1],
                },
                o: {
                  x: [0.42],
                  y: [0],
                },
                t: 12,
                s: [5],
              },
              {
                i: {
                  x: [0.58],
                  y: [1],
                },
                o: {
                  x: [0.42],
                  y: [0],
                },
                t: 24,
                s: [-10],
              },
              {
                t: 37,
                s: [0],
              },
            ],
            ix: 10,
          },
          p: {
            a: 0,
            k: [44.5, 54.75, 0],
            ix: 2,
            l: 2,
          },
          a: {
            a: 0,
            k: [44.5, 54.75, 0],
            ix: 1,
            l: 2,
          },
          s: {
            a: 1,
            k: [
              {
                i: {
                  x: [0.58, 0.58, 0.58],
                  y: [1, 1, 1],
                },
                o: {
                  x: [0.42, 0.42, 0.42],
                  y: [0, 0, 0],
                },
                t: 37,
                s: [100, 100, 100],
              },
              {
                i: {
                  x: [0.58, 0.58, 0.58],
                  y: [1, 1, 1],
                },
                o: {
                  x: [0.42, 0.42, 0.42],
                  y: [0, 0, 0],
                },
                t: 41,
                s: [106, 106, 100],
              },
              {
                t: 45,
                s: [100, 100, 100],
              },
            ],
            ix: 6,
            l: 2,
          },
        },
        ao: 0,
        w: 90,
        h: 90,
        ip: 0,
        op: 50,
        st: 0,
        bm: 0,
      },
      {
        ddd: 0,
        ind: 4,
        ty: 2,
        nm: "zixun.eps",
        cl: "eps",
        hd: true,
        refId: "image_0",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11,
          },
          r: {
            a: 0,
            k: 0,
            ix: 10,
          },
          p: {
            a: 0,
            k: [44.875, 30.5, 0],
            ix: 2,
            l: 2,
          },
          a: {
            a: 0,
            k: [410, 340, 0],
            ix: 1,
            l: 2,
          },
          s: {
            a: 0,
            k: [8, 8, 100],
            ix: 6,
            l: 2,
          },
        },
        ao: 0,
        ip: 0,
        op: 65,
        st: 0,
        bm: 0,
      },
      {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: "“咨询本专家”轮廓",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11,
          },
          r: {
            a: 0,
            k: 0,
            ix: 10,
          },
          p: {
            a: 0,
            k: [4.943, 80.517, 0],
            ix: 2,
            l: 2,
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1,
            l: 2,
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6,
            l: 2,
          },
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-0.483, 0.87],
                      [0, 0],
                      [0.371, -0.435],
                      [0, 0],
                      [-0.483, 1.096],
                      [0, 0],
                      [0, 0],
                      [-0.097, 0.403],
                      [0, 0],
                      [1.08, -1.063],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.322, 0.612],
                      [0, 0],
                      [0.548, -0.709],
                      [0, 0],
                      [0, 0],
                      [0.129, -0.354],
                      [0, 0],
                      [-0.387, 1.547],
                      [0, 0],
                      [0.693, -0.693],
                    ],
                    v: [
                      [7.928, -10.506],
                      [13.02, -10.506],
                      [11.972, -8.927],
                      [13.116, -8.024],
                      [14.663, -10.731],
                      [14.663, -11.956],
                      [8.572, -11.956],
                      [8.911, -13.1],
                      [7.396, -13.293],
                      [5.205, -9.378],
                      [6.155, -8.153],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "咨",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [1.063, 0.677],
                      [0, 0],
                      [-0.612, -0.661],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [1.16, 0.757],
                      [0, 0],
                      [-0.741, -0.709],
                    ],
                    v: [
                      [2.288, -12.923],
                      [1.257, -11.94],
                      [3.916, -9.813],
                      [4.979, -10.844],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "咨",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 2,
                ty: "sh",
                ix: 3,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [1.289, -0.935],
                      [0, 0],
                      [-1.176, 1.434],
                    ],
                    o: [
                      [-1.047, 1.257],
                      [0, 0],
                      [1.257, -0.935],
                      [0, 0],
                    ],
                    v: [
                      [4.383, -8.975],
                      [0.886, -5.672],
                      [1.885, -4.544],
                      [5.543, -8.105],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "咨",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 3,
                ty: "sh",
                ix: 4,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [13.503, -4.351],
                      [2.675, -4.351],
                      [2.675, 1.676],
                      [4.173, 1.676],
                      [4.173, 0.983],
                      [12.004, 0.983],
                      [12.004, 1.676],
                      [13.503, 1.676],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "咨",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 4,
                ty: "sh",
                ix: 5,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [4.173, -0.451],
                      [4.173, -2.917],
                      [12.004, -2.917],
                      [12.004, -0.451],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "咨",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 5,
                ty: "sh",
                ix: 6,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0.725, -0.645],
                      [1.627, -0.338],
                      [0, 0],
                      [-0.773, 0.773],
                      [-0.226, 0.354],
                      [-2.272, -0.612],
                      [0, 0],
                      [0.661, 1.418],
                      [-0.064, 0.387],
                    ],
                    o: [
                      [-0.161, 1.16],
                      [-0.709, 0.628],
                      [0, 0],
                      [1.966, -0.451],
                      [0.274, -0.29],
                      [0.87, 1.321],
                      [0, 0],
                      [-2.578, -0.58],
                      [0.097, -0.354],
                      [0, 0],
                    ],
                    v: [
                      [9.458, -10.151],
                      [8.121, -7.428],
                      [4.625, -5.978],
                      [5.188, -4.641],
                      [9.313, -6.494],
                      [10.055, -7.46],
                      [14.776, -4.576],
                      [15.517, -5.914],
                      [10.667, -8.911],
                      [10.893, -10.006],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "咨",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ty: "mm",
                mm: 1,
                nm: "合并路径 1",
                mn: "ADBE Vector Filter - Merge",
                hd: false,
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [0, 0, 0, 1],
                  ix: 3,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4,
                },
                w: {
                  a: 0,
                  k: 2,
                  ix: 5,
                },
                lc: 1,
                lj: 1,
                ml: 4,
                bm: 0,
                nm: "描边 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: true,
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [0.921569943896, 0.921569943896, 0.921569943896, 1],
                  ix: 4,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5,
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false,
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [0, 0],
                  ix: 2,
                },
                a: {
                  a: 0,
                  k: [0, 0],
                  ix: 1,
                },
                s: {
                  a: 0,
                  k: [100, 100],
                  ix: 3,
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7,
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4,
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5,
                },
                nm: "变换",
              },
            ],
            nm: "咨",
            np: 9,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-0.209, 0.226],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.322, 0.58],
                      [0, 0],
                      [0.097, -0.902],
                      [0.612, 0],
                      [0.677, 0.048],
                      [0, 0],
                      [-0.306, 0],
                      [-0.161, 1.241],
                      [0, 6.091],
                      [0, 0],
                      [-0.129, 0.516],
                      [0, 0],
                      [1.305, -1.289],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.403, -0.516],
                      [0, 0],
                      [-0.032, 5.188],
                      [-0.097, 0.79],
                      [-0.483, 0],
                      [0, 0],
                      [0.757, 0.032],
                      [1.386, 0],
                      [0.161, -1.418],
                      [0, 0],
                      [0.161, -0.467],
                      [0, 0],
                      [-0.451, 1.837],
                      [0, 0],
                      [0.226, -0.226],
                    ],
                    v: [
                      [22.703, -8.041],
                      [22.703, -0.935],
                      [27.859, -0.935],
                      [27.859, -8.508],
                      [23.09, -8.508],
                      [24.169, -10.135],
                      [29.487, -10.135],
                      [29.31, -0.999],
                      [28.23, 0.193],
                      [26.474, 0.113],
                      [26.844, 1.482],
                      [28.439, 1.547],
                      [30.776, -0.322],
                      [31.018, -11.585],
                      [24.83, -11.585],
                      [25.281, -13.052],
                      [23.734, -13.277],
                      [21.108, -8.588],
                      [22.059, -7.364],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "询",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [26.425, -2.224],
                      [24.186, -2.224],
                      [24.186, -4.109],
                      [26.425, -4.109],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "询",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 2,
                ty: "sh",
                ix: 3,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [24.186, -5.366],
                      [24.186, -7.219],
                      [26.425, -7.219],
                      [26.425, -5.366],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "询",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 3,
                ty: "sh",
                ix: 4,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [1.031, 0.79],
                      [0, 0],
                      [-0.645, -0.757],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [1.128, 0.838],
                      [0, 0],
                      [-0.725, -0.806],
                    ],
                    v: [
                      [18.788, -13.084],
                      [17.724, -12.037],
                      [20.383, -9.636],
                      [21.43, -10.699],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "询",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 4,
                ty: "sh",
                ix: 5,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.258, -0.226],
                      [0, 0],
                      [-0.967, 0.951],
                      [0, 0],
                      [0.435, -0.403],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0.322],
                      [0, 0],
                      [1.096, -0.741],
                      [0, 0],
                      [-0.5, 0.5],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.612, -8.411],
                      [16.612, -6.945],
                      [18.868, -6.945],
                      [18.868, -1.031],
                      [18.465, -0.193],
                      [19.045, 1.176],
                      [22.155, -1.37],
                      [21.736, -2.981],
                      [20.334, -1.627],
                      [20.334, -8.411],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "询",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ty: "mm",
                mm: 1,
                nm: "合并路径 1",
                mn: "ADBE Vector Filter - Merge",
                hd: false,
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [0, 0, 0, 1],
                  ix: 3,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4,
                },
                w: {
                  a: 0,
                  k: 2,
                  ix: 5,
                },
                lc: 1,
                lj: 1,
                ml: 4,
                bm: 0,
                nm: "描边 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: true,
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [0.921569943896, 0.921569943896, 0.921569943896, 1],
                  ix: 4,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5,
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false,
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [0, 0],
                  ix: 2,
                },
                a: {
                  a: 0,
                  k: [0, 0],
                  ix: 1,
                },
                s: {
                  a: 0,
                  k: [100, 100],
                  ix: 3,
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7,
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4,
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5,
                },
                nm: "变换",
              },
            ],
            nm: "询",
            np: 8,
            cix: 2,
            bm: 0,
            ix: 2,
            mn: "ADBE Vector Group",
            hd: false,
          },
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [2.546, -1.708],
                      [0, 0],
                      [-1.16, 3.255],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-2.691, -2.32],
                      [0, 0],
                      [1.063, 2.417],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [-1.16, 2.675],
                      [0, 0],
                      [2.739, -2.095],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.08, 2.884],
                      [0, 0],
                      [-2.61, -1.901],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [33.112, -10.377],
                      [33.112, -8.911],
                      [38.075, -8.911],
                      [32.516, -2.32],
                      [33.402, -0.886],
                      [39.267, -8.911],
                      [39.283, -8.911],
                      [39.283, -2.981],
                      [36.093, -2.981],
                      [36.093, -1.515],
                      [39.283, -1.515],
                      [39.283, 1.66],
                      [40.83, 1.66],
                      [40.83, -1.515],
                      [44.149, -1.515],
                      [44.149, -2.981],
                      [40.83, -2.981],
                      [40.83, -8.911],
                      [40.846, -8.911],
                      [46.502, -1.096],
                      [47.549, -2.417],
                      [42.039, -8.911],
                      [46.985, -8.911],
                      [46.985, -10.377],
                      [40.83, -10.377],
                      [40.83, -13.165],
                      [39.283, -13.165],
                      [39.283, -10.377],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "本",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [0, 0, 0, 1],
                  ix: 3,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4,
                },
                w: {
                  a: 0,
                  k: 2,
                  ix: 5,
                },
                lc: 1,
                lj: 1,
                ml: 4,
                bm: 0,
                nm: "描边 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: true,
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [0.921569943896, 0.921569943896, 0.921569943896, 1],
                  ix: 4,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5,
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false,
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [0, 0],
                  ix: 2,
                },
                a: {
                  a: 0,
                  k: [0, 0],
                  ix: 1,
                },
                s: {
                  a: 0,
                  k: [100, 100],
                  ix: 3,
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7,
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4,
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5,
                },
                nm: "变换",
              },
            ],
            nm: "本",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 3,
            mn: "ADBE Vector Group",
            hd: false,
          },
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.387, -1.031],
                      [0, 0],
                      [1.37, -0.87],
                      [1.128, 0.29],
                      [0, 0],
                      [-2.401, -1.128],
                      [0, 0],
                      [0.87, 0.322],
                      [-0.741, 1.096],
                      [0, 0],
                      [0, 0],
                      [-0.193, 0.645],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.129, 0.564],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.113, 0.596],
                      [0, 0],
                      [0.129, -0.612],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.129, -0.548],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [-0.338, 1.112],
                      [0, 0],
                      [-0.79, 0.902],
                      [-1.031, -0.354],
                      [0, 0],
                      [2.514, 0.645],
                      [0, 0],
                      [-0.806, -0.354],
                      [1.547, -1.112],
                      [0, 0],
                      [0, 0],
                      [0.193, -0.564],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.129, -0.516],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.097, -0.548],
                      [0, 0],
                      [-0.129, 0.612],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.129, 0.548],
                      [0, 0],
                    ],
                    v: [
                      [48.773, -8.443],
                      [48.773, -6.977],
                      [52.882, -6.977],
                      [51.803, -3.771],
                      [59.602, -3.771],
                      [56.363, -1.128],
                      [53.124, -2.079],
                      [52.318, -0.886],
                      [59.698, 1.789],
                      [60.536, 0.467],
                      [58.022, -0.548],
                      [61.455, -3.851],
                      [61.455, -5.172],
                      [53.994, -5.172],
                      [54.558, -6.977],
                      [63.34, -6.977],
                      [63.34, -8.443],
                      [54.961, -8.443],
                      [55.348, -10.071],
                      [62.389, -10.071],
                      [62.389, -11.505],
                      [55.654, -11.505],
                      [55.976, -13.229],
                      [54.397, -13.358],
                      [54.026, -11.505],
                      [49.869, -11.505],
                      [49.869, -10.071],
                      [53.704, -10.071],
                      [53.301, -8.443],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "专",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [0, 0, 0, 1],
                  ix: 3,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4,
                },
                w: {
                  a: 0,
                  k: 2,
                  ix: 5,
                },
                lc: 1,
                lj: 1,
                ml: 4,
                bm: 0,
                nm: "描边 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: true,
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [0.921569943896, 0.921569943896, 0.921569943896, 1],
                  ix: 4,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5,
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false,
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [0, 0],
                  ix: 2,
                },
                a: {
                  a: 0,
                  k: [0, 0],
                  ix: 1,
                },
                s: {
                  a: 0,
                  k: [100, 100],
                  ix: 3,
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7,
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4,
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5,
                },
                nm: "变换",
              },
            ],
            nm: "专",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 4,
            mn: "ADBE Vector Group",
            hd: false,
          },
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-0.242, 0.064],
                      [-1.708, -1.434],
                      [0, 0],
                      [0.741, 1.885],
                      [-0.838, 0.532],
                      [0, 0],
                      [1.418, -0.419],
                      [0.467, 0.516],
                      [-0.387, 0.258],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.387, -0.161],
                      [1.482, -0.306],
                      [0, 0],
                      [-1.047, 0.5],
                      [-0.064, 0.032],
                      [-0.161, -0.209],
                      [2.626, -0.677],
                      [0, 0],
                      [-1.515, 1.128],
                      [-0.097, -0.322],
                      [3.142, -0.886],
                      [0, 0],
                      [-1.74, 1.305],
                      [0, -0.161],
                      [0.258, -0.322],
                      [0.902, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.419, 0.58],
                      [0, 1.289],
                      [0.242, 0.741],
                    ],
                    o: [
                      [0.773, 2.159],
                      [0, 0],
                      [-1.644, -1.16],
                      [0.951, -0.387],
                      [0, 0],
                      [-1.289, 0.822],
                      [-0.322, -0.58],
                      [0.354, -0.226],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.354, 0.177],
                      [-1.289, 0.532],
                      [0, 0],
                      [1.901, -0.564],
                      [0.048, -0.032],
                      [0.161, 0.193],
                      [-1.466, 1.047],
                      [0, 0],
                      [2.498, -0.725],
                      [0.129, 0.29],
                      [-1.756, 1.386],
                      [0, 0],
                      [2.804, -0.87],
                      [0, 0.145],
                      [0, 0.902],
                      [-0.226, 0.242],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.466, 0],
                      [0.354, -0.483],
                      [-0.016, -0.87],
                      [0.226, -0.064],
                    ],
                    v: [
                      [74.522, -4.496],
                      [78.244, 0.902],
                      [79.34, -0.371],
                      [75.747, -4.931],
                      [78.421, -6.3],
                      [77.39, -7.332],
                      [73.33, -5.479],
                      [72.153, -7.122],
                      [73.265, -7.847],
                      [76.842, -7.847],
                      [76.842, -9.265],
                      [67.271, -9.265],
                      [67.271, -7.847],
                      [70.88, -7.847],
                      [69.769, -7.348],
                      [65.611, -6.091],
                      [66.385, -4.818],
                      [70.816, -6.413],
                      [70.977, -6.494],
                      [71.444, -5.897],
                      [65.305, -3.319],
                      [66.062, -1.998],
                      [72.089, -4.77],
                      [72.443, -3.835],
                      [65.096, -0.419],
                      [65.869, 0.886],
                      [72.701, -2.369],
                      [72.717, -1.901],
                      [72.314, -0.081],
                      [70.623, 0.29],
                      [69.801, 0.29],
                      [70.316, 1.644],
                      [70.832, 1.644],
                      [73.652, 0.773],
                      [74.2, -1.901],
                      [73.813, -4.318],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "家",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0.177, 0.419],
                      [0, 0],
                      [-0.161, -0.419],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0.177, 0.338],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.161, -0.516],
                    ],
                    v: [
                      [72.427, -13.326],
                      [70.864, -13.052],
                      [71.38, -11.924],
                      [65.144, -11.924],
                      [65.144, -8.927],
                      [66.675, -8.927],
                      [66.675, -10.506],
                      [77.438, -10.506],
                      [77.438, -8.927],
                      [78.969, -8.927],
                      [78.969, -11.924],
                      [72.927, -11.924],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "家",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ty: "mm",
                mm: 1,
                nm: "合并路径 1",
                mn: "ADBE Vector Filter - Merge",
                hd: false,
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [0, 0, 0, 1],
                  ix: 3,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4,
                },
                w: {
                  a: 0,
                  k: 2,
                  ix: 5,
                },
                lc: 1,
                lj: 1,
                ml: 4,
                bm: 0,
                nm: "描边 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: true,
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [0.921569943896, 0.921569943896, 0.921569943896, 1],
                  ix: 4,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5,
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false,
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [0, 0],
                  ix: 2,
                },
                a: {
                  a: 0,
                  k: [0, 0],
                  ix: 1,
                },
                s: {
                  a: 0,
                  k: [100, 100],
                  ix: 3,
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7,
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4,
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5,
                },
                nm: "变换",
              },
            ],
            nm: "家",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 5,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
        ip: 0,
        op: 65,
        st: 0,
        bm: 0,
      },
      {
        ddd: 0,
        ind: 6,
        ty: 5,
        nm: "咨询本专家",
        hd: true,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11,
          },
          r: {
            a: 0,
            k: 0,
            ix: 10,
          },
          p: {
            a: 0,
            k: [4.943, 80.517, 0],
            ix: 2,
            l: 2,
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1,
            l: 2,
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6,
            l: 2,
          },
        },
        ao: 0,
        t: {
          d: {
            k: [
              {
                s: {
                  s: 16,
                  f: "PingFangSC-Medium",
                  t: "咨询本专家",
                  ca: 0,
                  j: 0,
                  tr: 0,
                  lh: 19.2,
                  ls: 0,
                  fc: [0.922, 0.922, 0.922],
                },
                t: 0,
              },
            ],
          },
          p: {},
          m: {
            g: 1,
            a: {
              a: 0,
              k: [0, 0],
              ix: 2,
            },
          },
          a: [],
        },
        ip: 0,
        op: 65,
        st: 0,
        bm: 0,
      },
      {
        ddd: 0,
        ind: 7,
        ty: 4,
        nm: "“咨询本专家 2”轮廓",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 68,
            ix: 11,
          },
          r: {
            a: 0,
            k: 0,
            ix: 10,
          },
          p: {
            a: 0,
            k: [4.943, 82.017, 0],
            ix: 2,
            l: 2,
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1,
            l: 2,
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6,
            l: 2,
          },
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-0.483, 0.87],
                      [0, 0],
                      [0.371, -0.435],
                      [0, 0],
                      [-0.483, 1.096],
                      [0, 0],
                      [0, 0],
                      [-0.097, 0.403],
                      [0, 0],
                      [1.08, -1.063],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [-0.322, 0.612],
                      [0, 0],
                      [0.548, -0.709],
                      [0, 0],
                      [0, 0],
                      [0.129, -0.354],
                      [0, 0],
                      [-0.387, 1.547],
                      [0, 0],
                      [0.693, -0.693],
                    ],
                    v: [
                      [7.928, -10.506],
                      [13.02, -10.506],
                      [11.972, -8.927],
                      [13.116, -8.024],
                      [14.663, -10.731],
                      [14.663, -11.956],
                      [8.572, -11.956],
                      [8.911, -13.1],
                      [7.396, -13.293],
                      [5.205, -9.378],
                      [6.155, -8.153],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "咨",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [1.063, 0.677],
                      [0, 0],
                      [-0.612, -0.661],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [1.16, 0.757],
                      [0, 0],
                      [-0.741, -0.709],
                    ],
                    v: [
                      [2.288, -12.923],
                      [1.257, -11.94],
                      [3.916, -9.813],
                      [4.979, -10.844],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "咨",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 2,
                ty: "sh",
                ix: 3,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [1.289, -0.935],
                      [0, 0],
                      [-1.176, 1.434],
                    ],
                    o: [
                      [-1.047, 1.257],
                      [0, 0],
                      [1.257, -0.935],
                      [0, 0],
                    ],
                    v: [
                      [4.383, -8.975],
                      [0.886, -5.672],
                      [1.885, -4.544],
                      [5.543, -8.105],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "咨",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 3,
                ty: "sh",
                ix: 4,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [13.503, -4.351],
                      [2.675, -4.351],
                      [2.675, 1.676],
                      [4.173, 1.676],
                      [4.173, 0.983],
                      [12.004, 0.983],
                      [12.004, 1.676],
                      [13.503, 1.676],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "咨",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 4,
                ty: "sh",
                ix: 5,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [4.173, -0.451],
                      [4.173, -2.917],
                      [12.004, -2.917],
                      [12.004, -0.451],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "咨",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 5,
                ty: "sh",
                ix: 6,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0.725, -0.645],
                      [1.627, -0.338],
                      [0, 0],
                      [-0.773, 0.773],
                      [-0.226, 0.354],
                      [-2.272, -0.612],
                      [0, 0],
                      [0.661, 1.418],
                      [-0.064, 0.387],
                    ],
                    o: [
                      [-0.161, 1.16],
                      [-0.709, 0.628],
                      [0, 0],
                      [1.966, -0.451],
                      [0.274, -0.29],
                      [0.87, 1.321],
                      [0, 0],
                      [-2.578, -0.58],
                      [0.097, -0.354],
                      [0, 0],
                    ],
                    v: [
                      [9.458, -10.151],
                      [8.121, -7.428],
                      [4.625, -5.978],
                      [5.188, -4.641],
                      [9.313, -6.494],
                      [10.055, -7.46],
                      [14.776, -4.576],
                      [15.517, -5.914],
                      [10.667, -8.911],
                      [10.893, -10.006],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "咨",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ty: "mm",
                mm: 1,
                nm: "合并路径 1",
                mn: "ADBE Vector Filter - Merge",
                hd: false,
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [0, 0, 0, 1],
                  ix: 3,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4,
                },
                w: {
                  a: 0,
                  k: 2,
                  ix: 5,
                },
                lc: 1,
                lj: 1,
                ml: 4,
                bm: 0,
                nm: "描边 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: true,
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [0, 0.19216000426, 0.866669957778, 1],
                  ix: 4,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5,
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false,
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [0, 0],
                  ix: 2,
                },
                a: {
                  a: 0,
                  k: [0, 0],
                  ix: 1,
                },
                s: {
                  a: 0,
                  k: [100, 100],
                  ix: 3,
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7,
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4,
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5,
                },
                nm: "变换",
              },
            ],
            nm: "咨",
            np: 9,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-0.209, 0.226],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.322, 0.58],
                      [0, 0],
                      [0.097, -0.902],
                      [0.612, 0],
                      [0.677, 0.048],
                      [0, 0],
                      [-0.306, 0],
                      [-0.161, 1.241],
                      [0, 6.091],
                      [0, 0],
                      [-0.129, 0.516],
                      [0, 0],
                      [1.305, -1.289],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.403, -0.516],
                      [0, 0],
                      [-0.032, 5.188],
                      [-0.097, 0.79],
                      [-0.483, 0],
                      [0, 0],
                      [0.757, 0.032],
                      [1.386, 0],
                      [0.161, -1.418],
                      [0, 0],
                      [0.161, -0.467],
                      [0, 0],
                      [-0.451, 1.837],
                      [0, 0],
                      [0.226, -0.226],
                    ],
                    v: [
                      [22.703, -8.041],
                      [22.703, -0.935],
                      [27.859, -0.935],
                      [27.859, -8.508],
                      [23.09, -8.508],
                      [24.169, -10.135],
                      [29.487, -10.135],
                      [29.31, -0.999],
                      [28.23, 0.193],
                      [26.474, 0.113],
                      [26.844, 1.482],
                      [28.439, 1.547],
                      [30.776, -0.322],
                      [31.018, -11.585],
                      [24.83, -11.585],
                      [25.281, -13.052],
                      [23.734, -13.277],
                      [21.108, -8.588],
                      [22.059, -7.364],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "询",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [26.425, -2.224],
                      [24.186, -2.224],
                      [24.186, -4.109],
                      [26.425, -4.109],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "询",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 2,
                ty: "sh",
                ix: 3,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [24.186, -5.366],
                      [24.186, -7.219],
                      [26.425, -7.219],
                      [26.425, -5.366],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "询",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 3,
                ty: "sh",
                ix: 4,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [1.031, 0.79],
                      [0, 0],
                      [-0.645, -0.757],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [1.128, 0.838],
                      [0, 0],
                      [-0.725, -0.806],
                    ],
                    v: [
                      [18.788, -13.084],
                      [17.724, -12.037],
                      [20.383, -9.636],
                      [21.43, -10.699],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "询",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 4,
                ty: "sh",
                ix: 5,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.258, -0.226],
                      [0, 0],
                      [-0.967, 0.951],
                      [0, 0],
                      [0.435, -0.403],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0.322],
                      [0, 0],
                      [1.096, -0.741],
                      [0, 0],
                      [-0.5, 0.5],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.612, -8.411],
                      [16.612, -6.945],
                      [18.868, -6.945],
                      [18.868, -1.031],
                      [18.465, -0.193],
                      [19.045, 1.176],
                      [22.155, -1.37],
                      [21.736, -2.981],
                      [20.334, -1.627],
                      [20.334, -8.411],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "询",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ty: "mm",
                mm: 1,
                nm: "合并路径 1",
                mn: "ADBE Vector Filter - Merge",
                hd: false,
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [0, 0, 0, 1],
                  ix: 3,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4,
                },
                w: {
                  a: 0,
                  k: 2,
                  ix: 5,
                },
                lc: 1,
                lj: 1,
                ml: 4,
                bm: 0,
                nm: "描边 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: true,
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [0, 0.19216000426, 0.866669957778, 1],
                  ix: 4,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5,
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false,
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [0, 0],
                  ix: 2,
                },
                a: {
                  a: 0,
                  k: [0, 0],
                  ix: 1,
                },
                s: {
                  a: 0,
                  k: [100, 100],
                  ix: 3,
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7,
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4,
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5,
                },
                nm: "变换",
              },
            ],
            nm: "询",
            np: 8,
            cix: 2,
            bm: 0,
            ix: 2,
            mn: "ADBE Vector Group",
            hd: false,
          },
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [2.546, -1.708],
                      [0, 0],
                      [-1.16, 3.255],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-2.691, -2.32],
                      [0, 0],
                      [1.063, 2.417],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [-1.16, 2.675],
                      [0, 0],
                      [2.739, -2.095],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.08, 2.884],
                      [0, 0],
                      [-2.61, -1.901],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [33.112, -10.377],
                      [33.112, -8.911],
                      [38.075, -8.911],
                      [32.516, -2.32],
                      [33.402, -0.886],
                      [39.267, -8.911],
                      [39.283, -8.911],
                      [39.283, -2.981],
                      [36.093, -2.981],
                      [36.093, -1.515],
                      [39.283, -1.515],
                      [39.283, 1.66],
                      [40.83, 1.66],
                      [40.83, -1.515],
                      [44.149, -1.515],
                      [44.149, -2.981],
                      [40.83, -2.981],
                      [40.83, -8.911],
                      [40.846, -8.911],
                      [46.502, -1.096],
                      [47.549, -2.417],
                      [42.039, -8.911],
                      [46.985, -8.911],
                      [46.985, -10.377],
                      [40.83, -10.377],
                      [40.83, -13.165],
                      [39.283, -13.165],
                      [39.283, -10.377],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "本",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [0, 0, 0, 1],
                  ix: 3,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4,
                },
                w: {
                  a: 0,
                  k: 2,
                  ix: 5,
                },
                lc: 1,
                lj: 1,
                ml: 4,
                bm: 0,
                nm: "描边 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: true,
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [0, 0.19216000426, 0.866669957778, 1],
                  ix: 4,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5,
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false,
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [0, 0],
                  ix: 2,
                },
                a: {
                  a: 0,
                  k: [0, 0],
                  ix: 1,
                },
                s: {
                  a: 0,
                  k: [100, 100],
                  ix: 3,
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7,
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4,
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5,
                },
                nm: "变换",
              },
            ],
            nm: "本",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 3,
            mn: "ADBE Vector Group",
            hd: false,
          },
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.387, -1.031],
                      [0, 0],
                      [1.37, -0.87],
                      [1.128, 0.29],
                      [0, 0],
                      [-2.401, -1.128],
                      [0, 0],
                      [0.87, 0.322],
                      [-0.741, 1.096],
                      [0, 0],
                      [0, 0],
                      [-0.193, 0.645],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.129, 0.564],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.113, 0.596],
                      [0, 0],
                      [0.129, -0.612],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.129, -0.548],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [-0.338, 1.112],
                      [0, 0],
                      [-0.79, 0.902],
                      [-1.031, -0.354],
                      [0, 0],
                      [2.514, 0.645],
                      [0, 0],
                      [-0.806, -0.354],
                      [1.547, -1.112],
                      [0, 0],
                      [0, 0],
                      [0.193, -0.564],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.129, -0.516],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.097, -0.548],
                      [0, 0],
                      [-0.129, 0.612],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.129, 0.548],
                      [0, 0],
                    ],
                    v: [
                      [48.773, -8.443],
                      [48.773, -6.977],
                      [52.882, -6.977],
                      [51.803, -3.771],
                      [59.602, -3.771],
                      [56.363, -1.128],
                      [53.124, -2.079],
                      [52.318, -0.886],
                      [59.698, 1.789],
                      [60.536, 0.467],
                      [58.022, -0.548],
                      [61.455, -3.851],
                      [61.455, -5.172],
                      [53.994, -5.172],
                      [54.558, -6.977],
                      [63.34, -6.977],
                      [63.34, -8.443],
                      [54.961, -8.443],
                      [55.348, -10.071],
                      [62.389, -10.071],
                      [62.389, -11.505],
                      [55.654, -11.505],
                      [55.976, -13.229],
                      [54.397, -13.358],
                      [54.026, -11.505],
                      [49.869, -11.505],
                      [49.869, -10.071],
                      [53.704, -10.071],
                      [53.301, -8.443],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "专",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [0, 0, 0, 1],
                  ix: 3,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4,
                },
                w: {
                  a: 0,
                  k: 2,
                  ix: 5,
                },
                lc: 1,
                lj: 1,
                ml: 4,
                bm: 0,
                nm: "描边 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: true,
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [0, 0.19216000426, 0.866669957778, 1],
                  ix: 4,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5,
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false,
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [0, 0],
                  ix: 2,
                },
                a: {
                  a: 0,
                  k: [0, 0],
                  ix: 1,
                },
                s: {
                  a: 0,
                  k: [100, 100],
                  ix: 3,
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7,
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4,
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5,
                },
                nm: "变换",
              },
            ],
            nm: "专",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 4,
            mn: "ADBE Vector Group",
            hd: false,
          },
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-0.242, 0.064],
                      [-1.708, -1.434],
                      [0, 0],
                      [0.741, 1.885],
                      [-0.838, 0.532],
                      [0, 0],
                      [1.418, -0.419],
                      [0.467, 0.516],
                      [-0.387, 0.258],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.387, -0.161],
                      [1.482, -0.306],
                      [0, 0],
                      [-1.047, 0.5],
                      [-0.064, 0.032],
                      [-0.161, -0.209],
                      [2.626, -0.677],
                      [0, 0],
                      [-1.515, 1.128],
                      [-0.097, -0.322],
                      [3.142, -0.886],
                      [0, 0],
                      [-1.74, 1.305],
                      [0, -0.161],
                      [0.258, -0.322],
                      [0.902, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.419, 0.58],
                      [0, 1.289],
                      [0.242, 0.741],
                    ],
                    o: [
                      [0.773, 2.159],
                      [0, 0],
                      [-1.644, -1.16],
                      [0.951, -0.387],
                      [0, 0],
                      [-1.289, 0.822],
                      [-0.322, -0.58],
                      [0.354, -0.226],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.354, 0.177],
                      [-1.289, 0.532],
                      [0, 0],
                      [1.901, -0.564],
                      [0.048, -0.032],
                      [0.161, 0.193],
                      [-1.466, 1.047],
                      [0, 0],
                      [2.498, -0.725],
                      [0.129, 0.29],
                      [-1.756, 1.386],
                      [0, 0],
                      [2.804, -0.87],
                      [0, 0.145],
                      [0, 0.902],
                      [-0.226, 0.242],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.466, 0],
                      [0.354, -0.483],
                      [-0.016, -0.87],
                      [0.226, -0.064],
                    ],
                    v: [
                      [74.522, -4.496],
                      [78.244, 0.902],
                      [79.34, -0.371],
                      [75.747, -4.931],
                      [78.421, -6.3],
                      [77.39, -7.332],
                      [73.33, -5.479],
                      [72.153, -7.122],
                      [73.265, -7.847],
                      [76.842, -7.847],
                      [76.842, -9.265],
                      [67.271, -9.265],
                      [67.271, -7.847],
                      [70.88, -7.847],
                      [69.769, -7.348],
                      [65.611, -6.091],
                      [66.385, -4.818],
                      [70.816, -6.413],
                      [70.977, -6.494],
                      [71.444, -5.897],
                      [65.305, -3.319],
                      [66.062, -1.998],
                      [72.089, -4.77],
                      [72.443, -3.835],
                      [65.096, -0.419],
                      [65.869, 0.886],
                      [72.701, -2.369],
                      [72.717, -1.901],
                      [72.314, -0.081],
                      [70.623, 0.29],
                      [69.801, 0.29],
                      [70.316, 1.644],
                      [70.832, 1.644],
                      [73.652, 0.773],
                      [74.2, -1.901],
                      [73.813, -4.318],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "家",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0.177, 0.419],
                      [0, 0],
                      [-0.161, -0.419],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0.177, 0.338],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.161, -0.516],
                    ],
                    v: [
                      [72.427, -13.326],
                      [70.864, -13.052],
                      [71.38, -11.924],
                      [65.144, -11.924],
                      [65.144, -8.927],
                      [66.675, -8.927],
                      [66.675, -10.506],
                      [77.438, -10.506],
                      [77.438, -8.927],
                      [78.969, -8.927],
                      [78.969, -11.924],
                      [72.927, -11.924],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "家",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ty: "mm",
                mm: 1,
                nm: "合并路径 1",
                mn: "ADBE Vector Filter - Merge",
                hd: false,
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [0, 0, 0, 1],
                  ix: 3,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4,
                },
                w: {
                  a: 0,
                  k: 2,
                  ix: 5,
                },
                lc: 1,
                lj: 1,
                ml: 4,
                bm: 0,
                nm: "描边 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: true,
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [0, 0.19216000426, 0.866669957778, 1],
                  ix: 4,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5,
                },
                r: 1,
                bm: 0,
                nm: "填充 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false,
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [0, 0],
                  ix: 2,
                },
                a: {
                  a: 0,
                  k: [0, 0],
                  ix: 1,
                },
                s: {
                  a: 0,
                  k: [100, 100],
                  ix: 3,
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6,
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7,
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4,
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5,
                },
                nm: "变换",
              },
            ],
            nm: "家",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 5,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
        ip: 0,
        op: 65,
        st: 0,
        bm: 0,
      },
      {
        ddd: 0,
        ind: 8,
        ty: 5,
        nm: "咨询本专家 2",
        hd: true,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 68,
            ix: 11,
          },
          r: {
            a: 0,
            k: 0,
            ix: 10,
          },
          p: {
            a: 0,
            k: [4.943, 82.017, 0],
            ix: 2,
            l: 2,
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1,
            l: 2,
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6,
            l: 2,
          },
        },
        ao: 0,
        t: {
          d: {
            k: [
              {
                s: {
                  s: 16,
                  f: "PingFangSC-Medium",
                  t: "咨询本专家",
                  ca: 0,
                  j: 0,
                  tr: 0,
                  lh: 19.2,
                  ls: 0,
                  fc: [0, 0.192, 0.867],
                },
                t: 0,
              },
            ],
          },
          p: {},
          m: {
            g: 1,
            a: {
              a: 0,
              k: [0, 0],
              ix: 2,
            },
          },
          a: [],
        },
        ip: 0,
        op: 65,
        st: 0,
        bm: 0,
      },
      {
        ddd: 0,
        ind: 9,
        ty: 4,
        nm: "形状图层 2",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11,
          },
          r: {
            a: 0,
            k: 0,
            ix: 10,
          },
          p: {
            a: 0,
            k: [45.057, 74.733, 0],
            ix: 2,
            l: 2,
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1,
            l: 2,
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6,
            l: 2,
          },
        },
        ao: 0,
        shapes: [
          {
            ty: "rc",
            d: 1,
            s: {
              a: 0,
              k: [90, 30],
              ix: 2,
            },
            p: {
              a: 0,
              k: [0, 0],
              ix: 3,
            },
            r: {
              a: 0,
              k: 15,
              ix: 4,
            },
            nm: "矩形路径 1",
            mn: "ADBE Vector Shape - Rect",
            hd: false,
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [0.20000000298, 0.368627458811, 0.949019610882, 1],
              ix: 4,
            },
            o: {
              a: 0,
              k: 100,
              ix: 5,
            },
            r: 1,
            bm: 0,
            nm: "填充 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false,
          },
        ],
        ip: 0,
        op: 65,
        st: 0,
        bm: 0,
      },
      {
        ddd: 0,
        ind: 10,
        ty: 4,
        nm: "形状图层 1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11,
          },
          r: {
            a: 0,
            k: 0,
            ix: 10,
          },
          p: {
            a: 0,
            k: [44.875, 45, 0],
            ix: 2,
            l: 2,
          },
          a: {
            a: 0,
            k: [0, 0, 0],
            ix: 1,
            l: 2,
          },
          s: {
            a: 0,
            k: [100, 100, 100],
            ix: 6,
            l: 2,
          },
        },
        ao: 0,
        shapes: [
          {
            ty: "rc",
            d: 1,
            s: {
              a: 0,
              k: [90, 90],
              ix: 2,
            },
            p: {
              a: 0,
              k: [0, 0],
              ix: 3,
            },
            r: {
              a: 0,
              k: 20,
              ix: 4,
            },
            nm: "矩形路径 1",
            mn: "ADBE Vector Shape - Rect",
            hd: false,
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [0.20000000298, 0.368627458811, 0.949019610882, 1],
              ix: 4,
            },
            o: {
              a: 0,
              k: 20,
              ix: 5,
            },
            r: 1,
            bm: 0,
            nm: "填充 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false,
          },
        ],
        ip: 0,
        op: 65,
        st: 0,
        bm: 0,
      },
    ],
    markers: [],
    chars: [
      {
        ch: "咨",
        size: 16,
        style: "Medium",
        w: 100,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [14.2, 10.5],
                        [30.6, 10.5],
                        [30.6, 3.8],
                        [21, 3.8],
                        [21, -75.6],
                        [30.6, -75.6],
                        [30.6, -82.5],
                        [14.2, -82.5],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "[",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
              ],
              nm: "[",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
        },
        fFamily: "PingFang SC",
      },
      {
        ch: "询",
        size: 16,
        style: "Medium",
        w: 100,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-3.021, 5.438],
                        [0, 0],
                        [2.316, -2.719],
                        [0, 0],
                        [-3.021, 6.848],
                        [0, 0],
                        [0, 0],
                        [-0.604, 2.518],
                        [0, 0],
                        [6.747, -6.647],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [-2.014, 3.827],
                        [0, 0],
                        [3.424, -4.431],
                        [0, 0],
                        [0, 0],
                        [0.806, -2.216],
                        [0, 0],
                        [-2.417, 9.668],
                        [0, 0],
                        [4.33, -4.33],
                      ],
                      v: [
                        [49.548, -65.662],
                        [81.372, -65.662],
                        [74.826, -55.792],
                        [81.976, -50.153],
                        [91.644, -67.072],
                        [91.644, -74.725],
                        [53.577, -74.725],
                        [55.692, -81.876],
                        [46.225, -83.084],
                        [32.529, -58.612],
                        [38.47, -50.958],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "咨",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [6.647, 4.23],
                        [0, 0],
                        [-3.827, -4.129],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [7.251, 4.733],
                        [0, 0],
                        [-4.633, -4.431],
                      ],
                      v: [
                        [14.301, -80.768],
                        [7.855, -74.625],
                        [24.472, -61.331],
                        [31.119, -67.776],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "咨",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 2,
                  ty: "sh",
                  ix: 3,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [8.057, -5.841],
                        [0, 0],
                        [-7.352, 8.963],
                      ],
                      o: [
                        [-6.546, 7.855],
                        [0, 0],
                        [7.855, -5.841],
                        [0, 0],
                      ],
                      v: [
                        [27.393, -56.094],
                        [5.539, -35.449],
                        [11.783, -28.4],
                        [34.644, -50.656],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "咨",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 3,
                  ty: "sh",
                  ix: 4,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [84.393, -27.191],
                        [16.718, -27.191],
                        [16.718, 10.474],
                        [26.083, 10.474],
                        [26.083, 6.143],
                        [75.027, 6.143],
                        [75.027, 10.474],
                        [84.393, 10.474],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "咨",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 4,
                  ty: "sh",
                  ix: 5,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [26.083, -2.82],
                        [26.083, -18.228],
                        [75.027, -18.228],
                        [75.027, -2.82],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "咨",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 5,
                  ty: "sh",
                  ix: 6,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [4.532, -4.028],
                        [10.172, -2.115],
                        [0, 0],
                        [-4.834, 4.834],
                        [-1.41, 2.216],
                        [-14.2, -3.827],
                        [0, 0],
                        [4.129, 8.862],
                        [-0.403, 2.417],
                      ],
                      o: [
                        [-1.007, 7.251],
                        [-4.431, 3.928],
                        [0, 0],
                        [12.286, -2.82],
                        [1.712, -1.813],
                        [5.438, 8.258],
                        [0, 0],
                        [-16.113, -3.625],
                        [0.604, -2.216],
                        [0, 0],
                      ],
                      v: [
                        [59.116, -63.446],
                        [50.757, -46.426],
                        [28.903, -37.363],
                        [32.428, -29.004],
                        [58.209, -40.585],
                        [62.842, -46.628],
                        [92.349, -28.601],
                        [96.982, -36.96],
                        [66.669, -55.692],
                        [68.079, -62.54],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "咨",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
              ],
              nm: "咨",
              np: 9,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
        },
        fFamily: "PingFang SC",
      },
      {
        ch: "本",
        size: 16,
        style: "Medium",
        w: 100,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [15.912, -10.675],
                        [0, 0],
                        [-7.251, 20.343],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-16.818, -14.502],
                        [0, 0],
                        [6.647, 15.106],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [-7.251, 16.718],
                        [0, 0],
                        [17.12, -13.092],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [6.747, 18.027],
                        [0, 0],
                        [-16.315, -11.884],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [6.949, -64.856],
                        [6.949, -55.692],
                        [37.967, -55.692],
                        [3.223, -14.502],
                        [8.762, -5.539],
                        [45.419, -55.692],
                        [45.52, -55.692],
                        [45.52, -18.631],
                        [25.58, -18.631],
                        [25.58, -9.467],
                        [45.52, -9.467],
                        [45.52, 10.373],
                        [55.188, 10.373],
                        [55.188, -9.467],
                        [75.934, -9.467],
                        [75.934, -18.631],
                        [55.188, -18.631],
                        [55.188, -55.692],
                        [55.289, -55.692],
                        [90.637, -6.848],
                        [97.183, -15.106],
                        [62.741, -55.692],
                        [93.658, -55.692],
                        [93.658, -64.856],
                        [55.188, -64.856],
                        [55.188, -82.278],
                        [45.52, -82.278],
                        [45.52, -64.856],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "本",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
              ],
              nm: "本",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
        },
        fFamily: "PingFang SC",
      },
      {
        ch: "专",
        size: 16,
        style: "Medium",
        w: 100,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [2.417, -6.445],
                        [0, 0],
                        [8.56, -5.438],
                        [7.05, 1.813],
                        [0, 0],
                        [-15.005, -7.05],
                        [0, 0],
                        [5.438, 2.014],
                        [-4.633, 6.848],
                        [0, 0],
                        [0, 0],
                        [-1.208, 4.028],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.806, 3.525],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.705, 3.726],
                        [0, 0],
                        [0.806, -3.827],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.806, -3.424],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [-2.115, 6.949],
                        [0, 0],
                        [-4.935, 5.64],
                        [-6.445, -2.216],
                        [0, 0],
                        [15.71, 4.028],
                        [0, 0],
                        [-5.035, -2.216],
                        [9.668, -6.949],
                        [0, 0],
                        [0, 0],
                        [1.208, -3.525],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.806, -3.223],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.604, -3.424],
                        [0, 0],
                        [-0.806, 3.827],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.806, 3.424],
                        [0, 0],
                      ],
                      v: [
                        [4.834, -52.771],
                        [4.834, -43.607],
                        [30.515, -43.607],
                        [23.767, -23.566],
                        [72.51, -23.566],
                        [52.267, -7.05],
                        [32.025, -12.991],
                        [26.99, -5.539],
                        [73.114, 11.179],
                        [78.351, 2.921],
                        [62.64, -3.424],
                        [84.091, -24.069],
                        [84.091, -32.327],
                        [37.463, -32.327],
                        [40.988, -43.607],
                        [95.874, -43.607],
                        [95.874, -52.771],
                        [43.506, -52.771],
                        [45.923, -62.943],
                        [89.932, -62.943],
                        [89.932, -71.906],
                        [47.836, -71.906],
                        [49.85, -82.681],
                        [39.981, -83.487],
                        [37.665, -71.906],
                        [11.682, -71.906],
                        [11.682, -62.943],
                        [35.651, -62.943],
                        [33.133, -52.771],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "专",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
              ],
              nm: "专",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
        },
        fFamily: "PingFang SC",
      },
      {
        ch: "家",
        size: 16,
        style: "Medium",
        w: 100,
        data: {
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [-1.511, 0.403],
                        [-10.675, -8.963],
                        [0, 0],
                        [4.633, 11.783],
                        [-5.237, 3.323],
                        [0, 0],
                        [8.862, -2.618],
                        [2.921, 3.223],
                        [-2.417, 1.611],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [2.417, -1.007],
                        [9.265, -1.913],
                        [0, 0],
                        [-6.546, 3.122],
                        [-0.403, 0.201],
                        [-1.007, -1.309],
                        [16.415, -4.23],
                        [0, 0],
                        [-9.467, 7.05],
                        [-0.604, -2.014],
                        [19.638, -5.539],
                        [0, 0],
                        [-10.876, 8.157],
                        [0, -1.007],
                        [1.611, -2.014],
                        [5.64, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-2.618, 3.625],
                        [0, 8.057],
                        [1.511, 4.633],
                      ],
                      o: [
                        [4.834, 13.495],
                        [0, 0],
                        [-10.272, -7.251],
                        [5.942, -2.417],
                        [0, 0],
                        [-8.057, 5.136],
                        [-2.014, -3.625],
                        [2.216, -1.41],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-2.216, 1.108],
                        [-8.057, 3.323],
                        [0, 0],
                        [11.884, -3.525],
                        [0.302, -0.201],
                        [1.007, 1.208],
                        [-9.164, 6.546],
                        [0, 0],
                        [15.61, -4.532],
                        [0.806, 1.813],
                        [-10.977, 8.661],
                        [0, 0],
                        [17.523, -5.438],
                        [0, 0.906],
                        [0, 5.64],
                        [-1.41, 1.511],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [9.164, 0],
                        [2.216, -3.021],
                        [-0.101, -5.438],
                        [1.41, -0.403],
                      ],
                      v: [
                        [65.762, -28.098],
                        [89.026, 5.64],
                        [95.874, -2.316],
                        [73.416, -30.817],
                        [90.134, -39.377],
                        [83.688, -45.822],
                        [58.31, -34.241],
                        [50.958, -44.513],
                        [57.907, -49.045],
                        [80.264, -49.045],
                        [80.264, -57.907],
                        [20.444, -57.907],
                        [20.444, -49.045],
                        [43.002, -49.045],
                        [36.053, -45.923],
                        [10.071, -38.068],
                        [14.905, -30.112],
                        [42.599, -40.082],
                        [43.607, -40.585],
                        [46.527, -36.859],
                        [8.157, -20.746],
                        [12.891, -12.488],
                        [50.555, -29.81],
                        [52.771, -23.969],
                        [6.848, -2.618],
                        [11.682, 5.539],
                        [54.382, -14.804],
                        [54.483, -11.884],
                        [51.965, -0.504],
                        [41.391, 1.813],
                        [36.255, 1.813],
                        [39.478, 10.272],
                        [42.7, 10.272],
                        [60.324, 4.834],
                        [63.748, -11.884],
                        [61.331, -26.99],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "家",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ind: 1,
                  ty: "sh",
                  ix: 2,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [1.108, 2.618],
                        [0, 0],
                        [-1.007, -2.618],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [1.108, 2.115],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-1.007, -3.223],
                      ],
                      v: [
                        [52.67, -83.286],
                        [42.902, -81.573],
                        [46.124, -74.524],
                        [7.15, -74.524],
                        [7.15, -55.792],
                        [16.718, -55.792],
                        [16.718, -65.662],
                        [83.99, -65.662],
                        [83.99, -55.792],
                        [93.558, -55.792],
                        [93.558, -74.524],
                        [55.792, -74.524],
                      ],
                      c: true,
                    },
                    ix: 2,
                  },
                  nm: "家",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
              ],
              nm: "家",
              np: 5,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
        },
        fFamily: "PingFang SC",
      },
    ],
}